import React from 'react';
import Button from '@mui/joy/Button';
import Textarea from '@mui/joy/Textarea';
import SendIcon from '@mui/icons-material/Send';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { FieldErrors } from '../domain/helpers/Errors';
import { useDarkModeStore } from '../store/useDarkModeStore';

interface TextAreaCustomProp<T extends { [key: string]: any }> {
    form: T;
    name: string;
    view: boolean;
    errors: FieldErrors;
    isBtnDisabled?: boolean;
    isFeedbackMultitext?: boolean;
    className?: string;
    handleAddFeedback?: () => void;
    handleCameraClick?: () => void;
    setForm: React.Dispatch<React.SetStateAction<T>>;
}

export const TextAreaCustom = <T extends { [key: string]: any }>({
    name,
    form,
    view,
    errors,
    className = '',
    isBtnDisabled = false,
    isFeedbackMultitext = false,
    setForm,
    handleAddFeedback,
    handleCameraClick,

}: TextAreaCustomProp<T>) => {

    const { darkMode } = useDarkModeStore();

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { value } = e.target;
        delete errors?.[name];
        setForm({ ...form, [name]: value });
    }

    return <Textarea
        id={name}
        name={name}
        minRows={3}
        readOnly={view}
        placeholder="Text…"
        value={form?.[name] ?? ''}
        className={`${className} ${darkMode && "dark-mode-input"}`}
        onChange={handleChange}
        endDecorator={
            isFeedbackMultitext &&
            handleAddFeedback &&
            <div className='w-100 d-flex align-items-center justify-content-end'>
                <Button
                    variant="plain"
                    className='me-1 mb-1'
                    onClick={handleAddFeedback}
                    sx={{ width: 25, height: 25 }}
                    disabled={!(form?.[name].length > 0 || form?.formImages.length > 0) || isBtnDisabled}
                >
                    <SendIcon />
                </Button>
                {
                    handleCameraClick
                    && <Button
                        variant="plain"
                        className='me-1 mb-1'
                        sx={{ width: 25, height: 25 }}
                        onClick={handleCameraClick}
                    >
                        <AddPhotoAlternateIcon />
                    </Button>
                }
            </div>
        }
        sx={{
            minWidth: 300,
            '& textarea': {
                maxHeight: isFeedbackMultitext ? 100 : 'none',
                overflowY: isFeedbackMultitext ? 'auto !important' : 'visible',
            },
        }}
    />
}

export default TextAreaCustom;